<template>
    <div class="cookie-banner" id="cookie-banner" v-show="showModal">
        <div class="container" v-if="!showManageCookies">
            <div class="logo" v-if="!mietmich && !itr && !erotikum && !peppr"><img src="/images/erobella_logo_white.svg"></div>
            <div class="logo" v-if="mietmich && !itr"><img src="/images/ebmm.png"></div>
            <div class="logo" v-if="!itr && !mietmich && erotikum"><img src="/images/erotikum/erotikum.svg"></div>
            <div class="logo" v-if="!erotikum && itr"><img src="/images/itr/ebintimeslogo.png"></div>
            <div class="logo" v-if="!itr && !mietmich && !erotikum && peppr"><img src="/images/peppr/pepprlogo.svg"></div>
            <div class="content">
                <p v-if="mietmich && !itr">MietMich wurde zu Erobella: Mehr Girls, schnellere Website und bessere mobile Erfahrung - Willkommen bei Erobella!</p>
                <p v-if="itr">Intimes Revier wurde zu Erobella: Mehr Girls, schnellere Website und bessere mobile Erfahrung - Willkommen bei Erobella!</p>
                <p v-if="erotikum">Erotikum wurde zu Erobella: Mehr Girls, schnellere Website und bessere mobile Erfahrung - Willkommen bei Erobella!</p>
                <p v-if="!itr && !mietmich && !erotikum && peppr">Peppr wurde zu Erobella: Mehr Girls, schnellere Website und bessere mobile Erfahrung - Willkommen bei Erobella!</p>
                <p>{{translate.cookie_banner.bannerText2}}</p>
            </div>
            <div class="actions">
                <button
                        @click="onMainButtonClick()"
                        onclick="closeCookie()"
                        class="btn btn-secondary full-width d-flex flex-column">
                    <span>{{ translate.cookie_banner.ageConsent }}</span>
                    <span v-if="!hasCookiesSavedInStorage()">{{ translate.cookie_banner.allowAllCookies }}</span>
                </button>
                <div class="sub-actions">
                    <span e2e-id="adjust-cookie-settings" @click.prevent="showManageCookiesMenu()">{{translate.cookie_banner.manageCookieButton}}</span>
                    <span class="leave-link"
                          @click.prevent="onLeaveClick()"
                          onclick="cookiesLeavePage()"
                    >{{translate.cookie_banner.leaveButton}}</span>
                </div>
            </div>
        </div>
        <div class="container manage-cookies" v-if="showManageCookies">
            <div class="d-flex flex-column justify-content-center">
                <h5>{{translate.cookie_banner.manageCookieTitle}}</h5>
                <p>{{translate.cookie_banner.manageCookieSubtitle}}</p>
                <button @click="allowAllCookiesFromOptions()"
                        class="btn btn-secondary mt-2 mt-sm-3">{{translate.cookie_banner.allowAllButton}}
                </button>
            </div>

            <div class="manage-cookies-entry-wrap mt-3 mt-sm-5">
                <div class="manage-cookies-entry">
                    <div class="toggle-checkbox">
                        <input type="checkbox"
                               id="technology"
                               :checked="true"
                               disabled/>
                        <label for="technology">{{translate.cookie_banner.technology['title']}}</label>
                    </div>
                    <p class="m-0">{{translate.cookie_banner.technology['details']}}</p>
                </div>
                <div class="manage-cookies-entry">
                    <div class="toggle-checkbox">
                        <input type="checkbox"
                               id="functional"
                               @click="toggleAllowFunctional()"
                               :checked="allowFunctional === true"/>
                        <label for="functional">{{translate.cookie_banner.functional['title']}}</label>
                    </div>
                    <p class="m-0">{{translate.cookie_banner.functional['details']}}</p>
                </div>
                <div class="manage-cookies-entry">
                    <div class="toggle-checkbox">
                        <input type="checkbox"
                               id="marketing"
                               @click="toggleAllowMarketing()"
                               :checked="allowMarketing === true"/>
                        <label for="marketing">{{translate.cookie_banner.marketing['title']}}</label>
                    </div>
                    <p class="m-0">{{translate.cookie_banner.marketing['details']}}</p>
                </div>
            </div>

            <div class="d-flex justify-content-center mt-3">
                <button e2e-id="secondary-cookie-save-btn" @click="saveSelectedCookiesFromOptions()"
                        v-bind:class="{disabled: !hasTouchedAnyCookiesToggle }"
                        class="btn btn-secondary save-btn">{{translate.cookie_banner.SaveAndContinueButton}}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import xtrackingMixin from "@/components/mixins/xtrackingMixin";

    const localStorageKeyName = 'cookies-accepted';

    /**
     * The component works quite closely with header.blade.php and footer.blade.php.
     * More information in the header.blade.php file.
     */
    const data = () => {
        return {
            showModal: true,
            allowFunctional: false,
            allowMarketing: false,
            hasTouchedAnyCookiesToggle: false,
            didManageCookies: false,
            showManageCookies: false,
            mietmich: false,
            itr: false,
            erotikum: false,
            peppr: false,
            consentCookieName: 'erob_consent',
        }
    };

    function created() {
        // if the client.js file is loaded, then we want to set the global variable value to 'false'
        // to ensure that the 'closeCookie' function does not set the cookie as well.
        // More information available at the header.blade.php file level.
        if (typeof window !== 'undefined') {
            window.cookiesModalDisplayedWithoutVueJS = false;
        }

        if (typeof localStorage === 'undefined' || typeof Cookies2 === 'undefined') {
            this.showModal = false;
        }

        if (typeof mietmichCookie !== 'undefined') {
            this.mietmich = true;
        }

        if (typeof itrCookie !== 'undefined') {
            this.itr = true;
        }

        if (typeof erotikumCookie !== 'undefined') {
            this.erotikum = true;
        }

        if (typeof pepprCookie !== 'undefined') {
            this.peppr = true;
        }

        if (typeof window !== 'undefined' && typeof Cookies2 === 'undefined') {
            throw 'No instance of Cookies2 found in ModalCookiesComponent.';
        }
    }

    function mounted() {
        const cookiesDetails = this.resolveStoredSettings();

        if (cookiesDetails) {
            this.allowFunctional = cookiesDetails.functional;
            this.allowMarketing = cookiesDetails.marketing;
            this.hasTouchedAnyCookiesToggle = true;
            this.showModal = !cookiesDetails.isOverEighteen;
        }
    }

    function onMainButtonClick() {
        if (this.hasCookiesSavedInStorage()) {
            this.captureTrackingEvent(
                this.currentUser,
                'cookie_modal',
                'approve_age',
                'click'
            );
        } else {
            this.captureTrackingEvent(
                this.currentUser,
                'cookie_modal',
                'approve_all',
                'click',
                null,
                {'js_state': 'client_js'}
            );
        }

        const shouldReloadPage = this.hasTouchedAnyCookiesToggle;

        if (!this.hasCookiesSavedInStorage()) {
            this.allowAllCookies();
        }

        this.storeConsent(true);
        this.showModal = false;

        if (shouldReloadPage) {
            // in case, if not all cookies are allowed
            // then we need to refresh the page to ensure that they get unset.
            // otherwise, if all are allowed
            // there is no point to refresh the page
            location.reload();
        }
    }

    function onLeaveClick() {
        this.captureTrackingEvent(
            this.currentUser,
            'cookie_modal',
            'leave',
            'click',
            null,
            {'js_state': 'client_js'}
        );
        window.history.go(-1);
    }

    function hasCookiesSavedInStorage() {
        return Boolean((this.isCookieSet()) || this.didManageCookies);
    }

    function enableHasTouchedAnyCookiesToggle() {
        if (!this.hasTouchedAnyCookiesToggle) {
            this.hasTouchedAnyCookiesToggle = true;
        }
    }

    function allowAllCookiesFromOptions(){
        this.captureTrackingEvent(
            this.currentUser,
            'cookie_modal',
            'approve_all_options',
            'click',
        );

        this.allowAllCookies();
    }

    function allowAllCookies() {
        this.allowFunctional = this.allowMarketing = true;
        this.enableHasTouchedAnyCookiesToggle();
        this.saveCookiesPermissions();
    }

    function toggleAllowFunctional() {
        this.allowFunctional = !this.allowFunctional;
        this.enableHasTouchedAnyCookiesToggle();
    }

    function toggleAllowMarketing() {
        this.allowMarketing = !this.allowMarketing;
        this.enableHasTouchedAnyCookiesToggle();
    }

    function showManageCookiesMenu(){
        this.captureTrackingEvent(
            this.currentUser,
            'cookie_modal',
            'open_options',
            'click',
        );
        this.showManageCookies = true;
    }

    function hideManageCookiesMenu(){
        this.showManageCookies = false;
    }

    function serialisePayload(isOverEighteen) {
        let obj = {
            functional: this.allowFunctional,
            marketing: this.allowMarketing,
        };

        if (typeof isOverEighteen != 'undefined' && isOverEighteen) {
            obj['isOverEighteen'] = isOverEighteen;
        }

        return obj;
    }

    function saveSelectedCookiesFromOptions() {
        const selectedCookies = this.serialisePayload();

        this.captureTrackingEvent(
            this.currentUser,
            'cookie_modal',
            'approve_selected',
            'click',
            null,
            selectedCookies
        );

        this.saveCookiesPermissions();
    }

    function saveCookiesPermissions() {
        if (this.hasTouchedAnyCookiesToggle) {
            this.didManageCookies = true;
            this.hideManageCookiesMenu();
            this.storeConsent();
        }
    }

    function storeConsent(isOverEighteen) {
        let payload = this.serialisePayload(isOverEighteen);
        this.updateConsentCookie(payload);
    }

    function updateConsentCookie(payload) {
        if (!payload || typeof Cookies2 === 'undefined') {
            return;
        }

        let keySequence = ['functional', 'marketing', 'isOverEighteen'];
        let cookieValueArray = [];

        keySequence.forEach(function(key) {
            // convert booleans to string representations
            let booleanString = (typeof payload[key] != 'undefined' && payload[key]) ? 'true' : 'false';
            cookieValueArray.push(key + ':' + booleanString);
        });

        Cookies2.set(this.consentCookieName, cookieValueArray.join('|'), { expires: 360 * 3});
    }

    function isCookieSet()
    {
        if (typeof Cookies2 === 'undefined') {
            return false;
        }

        if (Cookies2.get(this.consentCookieName)) {
            return true;
        }

        return false;
    }

    function getCookieSettings()
    {
        let cookieSettings = {
            allowFunctional: false,
            allowMarketing: false,
            isOverEighteen: false
        };

        const cookieValue = Cookies2.get(this.consentCookieName);
        const cookieValueArray = cookieValue.split('|');
        let allowedKeys = ['functional', 'marketing', 'isOverEighteen'];

        cookieValueArray.forEach(function(cookieValuePart) {
            const partValues = cookieValuePart.split(':');
            if (allowedKeys.includes(partValues[0])) {
                cookieSettings[partValues[0]] = (partValues[1] === 'true' ? true : false);
            }
        });

        return cookieSettings;
    }

    function resolveStoredSettings()
    {
        if (typeof localStorage == 'undefined' || typeof Cookies2 == 'undefined') {
            return;
        }

        const localStorageDetails = localStorage.getItem(localStorageKeyName);

        // if the cookie is not set and the local-storage has settings
        // then we perform migration from "legacy" local-storage to the cookie storage.
        if (!this.isCookieSet() && localStorageDetails) {

            let parsedDetails = JSON.parse(localStorageDetails);
            this.updateConsentCookie(parsedDetails);

            // remove the local-storage item since we only use the cookie now
            localStorage.removeItem(localStorageKeyName);

            return parsedDetails;
        }

        if (this.isCookieSet()) {
            return this.getCookieSettings();
        }

        return null;
    }

    export default {
        data,
        created,
        mounted,
        methods: {
            onMainButtonClick,
            onLeaveClick,
            allowAllCookies,
            toggleAllowFunctional,
            toggleAllowMarketing,
            saveCookiesPermissions,
            serialisePayload,
            hasCookiesSavedInStorage,
            enableHasTouchedAnyCookiesToggle,
            storeConsent,
            updateConsentCookie,
            isCookieSet,
            resolveStoredSettings,
            getCookieSettings,
            showManageCookiesMenu,
            hideManageCookiesMenu,
            allowAllCookiesFromOptions,
            saveSelectedCookiesFromOptions,
        },
        computed: {
            ...mapState([
                'translate',
                'currentUser',
            ]),
        },
        mixins: [xtrackingMixin]
    };
</script>
